import '../../CSS/Search.css';
import '../../CSS/Services.css';
import { useState } from 'react';

// Component for the first image design
export const SearchBar = () => {
  const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [services, setServices] = useState(['Nanny', 'Gardener', 'House Keeper']);
  const [locationDropdownOpen, setLocationDropdownOpen] = useState(false);
  const [locations, setLocations] = useState(['Langatta, NHC', 'Other Location']);
  const [selectedLocation, setSelectedLocation] = useState('');

  return (
    <div className={"search-container"}>
      <div className={"search-container-inner"}>
        <div className={"search-section"}>
          <div className={"search-dropdown-input"} onClick={() => { setServiceDropdownOpen(!serviceDropdownOpen); }} style={{ position: 'relative' }}>
            <i class="bi bi-search"></i>
            <p>{selectedService || 'What are you looking for?'}</p>
            <i class="bi bi-chevron-down clickable-icon"></i>
            {serviceDropdownOpen && (
              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: 'white', border: '1px solid #ccc', zIndex: 1000, borderRadius: "8px" }}>
                {services.map((service) => (
                  <div style={{ padding: '10px', cursor: 'pointer' }} onClick={() => { setSelectedService(service); setServiceDropdownOpen(false); }}>{service}</div>
                ))}
              </div>
            )}
          </div>
          <div className={"search-location-input"} style={{ position: 'relative' }} onClick={() => { setLocationDropdownOpen(!locationDropdownOpen); }}>
            <i class="bi bi-geo-alt clickable-icon"></i>
            <p>{selectedLocation || 'Choose Location'}</p>
            {locationDropdownOpen && (
              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: 'white', border: '1px solid #ccc', zIndex: 1000, borderRadius: "8px" }}>
                {locations.map((location) => (
                  <div style={{ padding: '10px', cursor: 'pointer' }} onClick={() => { setSelectedLocation(location); setLocationDropdownOpen(false); }}>{location}</div>
                ))}
              </div>
            )}
          </div>
          <i class="bi bi-search search-icon"></i>
        </div>
        <div className={"buttons-section"}>
          <p className={"buttons-section-title"}>You may be looking for</p>
          <div className={"button-items"}>
            <div className={"best-services-chip"}>
              Emergency Childcare
              <i className={"bi bi-x"}></i>
            </div>
            <div className={"best-services-chip"}>
              Newborn Care
              <i className={"bi bi-x"}></i>
            </div>
            <div className={"best-services-chip"}>
              Toddler Care
              <i className={"bi bi-x"}></i>
            </div>
            <button className={"more-button"} type={"button"} onClick={(e) => { console.log("Navigate to page xyz") }}>More</button>
          </div>
        </div>
      </div>
    </div>
  );
};
